import { BaseModel } from '../../base/models/base-model.model';
import { Management } from '../../shared/DTO/management';
import { ServiceModel } from './service.model';
import { ServicesCombinationModel } from './services-combination.model';
import { CpaModel } from './cpa.model';
import { CpaPriceModel } from './cpa-price.model';
import { ProductCompositionModel } from './product-composition.model';
import { PropertyModel } from './property.model';
import { RequestModel } from './request.model';
import { DurationModel } from './duration.model';
import { ListString } from '../../shared/DTO/listString';
import { ListProductState } from '../../shared/DTO/listProductState';
import { ListAdmittedTransictionState } from '../../shared/DTO/listAdmittedTransictionState';
import { TransictionsModel } from './transictions.model';

export class ArticleModel extends BaseModel {
  private _article?: string;
  private _services?: Array<ServiceModel>;
  private _servicesCombinations?: Array<ServicesCombinationModel>;
  private _type?: string;
  private _additionalDescription?: string;
  private _admittedAdditionalRevoke?: ListString;
  private _admittedRevoke?: ListString;
  private _admittedStates?: ListProductState;
  private _admittedTransictionStates?: ListAdmittedTransictionState;
  private _appId?: string;
  private _code?: string;
  private _contractType?: string;
  private _cpa?: Array<CpaModel>;
  private _cpaPrices?: Array<CpaPriceModel>;
  private _deactivationCode?: string;
  private _description?: string;
  private _duration?: DurationModel;
  private _enabledProfiles?: Array<string>;
  private _family?: string;
  private _identityIpam3?: boolean;
  private _identityIsac?: boolean;
  private _identityLisa?: boolean;
  private _identityManagedByIsac?: boolean;
  private _identityMinosse?: boolean;
  private _identitySpid?: boolean;
  private _isecProfile?: boolean;
  private _mandatoryRevokeNote?: boolean;
  private _mainDomain?: string;
  private _management?: Management;
  private _noIdentity?: boolean;
  private _optional?: boolean;
  private _optionalOrder?: boolean;
  private _orderTemplate?: string;
  private _passwordPolicy?: string;
  private _postActivationName?: string;
  private _productsCompositions?: Array<ProductCompositionModel>;
  private _properties?: Array<PropertyModel>;
  private _reactivationCode?: string;
  private _request?: RequestModel;
  private _secondaryDomains?: Array<string>;
  private _separateIdentity?: boolean;
  private _warpFlow?: string;
  private _selected?: boolean;
  private _transictions?: TransictionsModel;
  private _active?: number;
  private _max: number;

  constructor(
    article?: string,
    services?: Array<ServiceModel>,
    servicesCombinations?: Array<ServicesCombinationModel>,
    type?: string,
    additionalDescription?: string,
    admittedAdditionalRevoke?: ListString,
    admittedRevoke?: ListString,
    admittedStates?: ListProductState,
    admittedTransictionStates?: ListAdmittedTransictionState,
    appId?: string,
    code?: string,
    contractType?: string,
    cpa?: Array<CpaModel>,
    cpaPrices?: Array<CpaPriceModel>,
    deactivationCode?: string,
    description?: string,
    duration?: DurationModel,
    enabledProfiles?: Array<string>,
    family?: string,
    identityIpam3?: boolean,
    identityIsac?: boolean,
    identityLisa?: boolean,
    identityManagedByIsac?: boolean,
    identityMinosse?: boolean,
    identitySpid?: boolean,
    isecProfile?: boolean,
    mainDomain?: string,
    management?: Management,
    noIdentity?: boolean,
    mandatoryRevokeNote?: boolean,
    optional?: boolean,
    optionalOrder?: boolean,
    orderTemplate?: string,
    passwordPolicy?: string,
    postActivationName?: string,
    productsCompositions?: Array<ProductCompositionModel>,
    properties?: Array<PropertyModel>,
    reactivationCode?: string,
    request?: RequestModel,
    secondaryDomains?: Array<string>,
    separateIdentity?: boolean,
    warpFlow?: string,
    selected?: boolean,
    transictions?: TransictionsModel,
    active?: number,
    max?: number
  ) {
    super();
    this._article = article;
    this._services = services;
    this._servicesCombinations = servicesCombinations;
    this._type = type;
    this._additionalDescription = additionalDescription;
    this._admittedAdditionalRevoke = admittedAdditionalRevoke;
    this._admittedRevoke = admittedRevoke;
    this._admittedStates = admittedStates;
    this._admittedTransictionStates = admittedTransictionStates;
    this._appId = appId;
    this._code = code;
    this._contractType = contractType;
    this._cpa = cpa;
    this._cpaPrices = cpaPrices;
    this._deactivationCode = deactivationCode;
    this._description = description;
    this._duration = duration;
    this._enabledProfiles = enabledProfiles;
    this._family = family;
    this._identityIpam3 = identityIpam3;
    this._identityIsac = identityIsac;
    this._identityLisa = identityLisa;
    this._identityManagedByIsac = identityManagedByIsac;
    this._identityMinosse = identityMinosse;
    this._identitySpid = identitySpid;
    this._isecProfile = isecProfile;
    this._mainDomain = mainDomain;
    this._management = management;
    this._noIdentity = noIdentity;
    this._mandatoryRevokeNote = mandatoryRevokeNote;
    this._optional = optional;
    this._optionalOrder = optionalOrder;
    this._orderTemplate = orderTemplate;
    this._passwordPolicy = passwordPolicy;
    this._postActivationName = postActivationName;
    this._productsCompositions = productsCompositions;
    this._properties = properties;
    this._reactivationCode = reactivationCode;
    this._request = request;
    this._secondaryDomains = secondaryDomains;
    this._separateIdentity = separateIdentity;
    this._warpFlow = warpFlow;
    this._selected = selected;
    this._transictions = transictions;
    this._active = active;
    this._max = max;
  }

  get transictions(): TransictionsModel {
    return this._transictions;
  }

  set transictions(value: TransictionsModel) {
    this._transictions = value;
  }

  get mandatoryRevokeNote(): boolean {
    return this._mandatoryRevokeNote;
  }

  set mandatoryRevokeNote(value: boolean) {
    this._mandatoryRevokeNote = value;
  }

  get admittedAdditionalRevoke(): ListString {
    return this._admittedAdditionalRevoke;
  }

  set admittedAdditionalRevoke(value: ListString) {
    this._admittedAdditionalRevoke = value;
  }

  get admittedRevoke(): ListString {
    return this._admittedRevoke;
  }

  set admittedRevoke(value: ListString) {
    this._admittedRevoke = value;
  }

  get admittedTransictionStates(): ListAdmittedTransictionState {
    return this._admittedTransictionStates;
  }

  set admittedTransictionStates(value: ListAdmittedTransictionState) {
    this._admittedTransictionStates = value;
  }

  get selected(): boolean {
    return this._selected;
  }

  set selected(value: boolean) {
    this._selected = value;
  }

  get family(): string {
    return this._family;
  }

  set family(value: string) {
    this._family = value;
  }

  get orderTemplate(): string {
    return this._orderTemplate;
  }

  set orderTemplate(value: string) {
    this._orderTemplate = value;
  }

  get separateIdentity(): boolean {
    return this._separateIdentity;
  }

  set separateIdentity(value: boolean) {
    this._separateIdentity = value;
  }

  get warpFlow(): string {
    return this._warpFlow;
  }

  set warpFlow(value: string) {
    this._warpFlow = value;
  }

  get article(): string {
    return this._article;
  }

  set article(value: string) {
    this._article = value;
  }

  get services(): Array<ServiceModel> {
    return this._services;
  }

  set services(value: Array<ServiceModel>) {
    this._services = value;
  }

  get servicesCombinations(): Array<ServicesCombinationModel> {
    return this._servicesCombinations;
  }

  set servicesCombinations(value: Array<ServicesCombinationModel>) {
    this._servicesCombinations = value;
  }

  get type(): string {
    return this._type;
  }

  set type(value: string) {
    this._type = value;
  }

  get additionalDescription(): string {
    return this._additionalDescription;
  }

  set additionalDescription(value: string) {
    this._additionalDescription = value;
  }

  get admittedStates(): ListProductState {
    return this._admittedStates;
  }

  set admittedStates(value: ListProductState) {
    this._admittedStates = value;
  }

  get appId(): string {
    return this._appId;
  }

  set appId(value: string) {
    this._appId = value;
  }

  get code(): string {
    return this._code;
  }

  set code(value: string) {
    this._code = value;
  }

  get contractType(): string {
    return this._contractType;
  }

  set contractType(value: string) {
    this._contractType = value;
  }

  get cpa(): Array<CpaModel> {
    return this._cpa;
  }

  set cpa(value: Array<CpaModel>) {
    this._cpa = value;
  }

  get cpaPrices(): Array<CpaPriceModel> {
    return this._cpaPrices;
  }

  set cpaPrices(value: Array<CpaPriceModel>) {
    this._cpaPrices = value;
  }

  get deactivationCode(): string {
    return this._deactivationCode;
  }

  set deactivationCode(value: string) {
    this._deactivationCode = value;
  }

  get description(): string {
    return this._description;
  }

  set description(value: string) {
    this._description = value;
  }

  get duration(): DurationModel {
    return this._duration;
  }

  set duration(value: DurationModel) {
    this._duration = value;
  }

  get enabledProfiles(): Array<string> {
    return this._enabledProfiles;
  }

  set enabledProfiles(value: Array<string>) {
    this._enabledProfiles = value;
  }

  get identityIpam3(): boolean {
    return this._identityIpam3;
  }

  set identityIpam3(value: boolean) {
    this._identityIpam3 = value;
  }

  get identityIsac(): boolean {
    return this._identityIsac;
  }

  set identityIsac(value: boolean) {
    this._identityIsac = value;
  }

  get identityLisa(): boolean {
    return this._identityLisa;
  }

  set identityLisa(value: boolean) {
    this._identityLisa = value;
  }

  get identityManagedByIsac(): boolean {
    return this._identityManagedByIsac;
  }

  set identityManagedByIsac(value: boolean) {
    this._identityManagedByIsac = value;
  }

  get identityMinosse(): boolean {
    return this._identityMinosse;
  }

  set identityMinosse(value: boolean) {
    this._identityMinosse = value;
  }

  get identitySpid(): boolean {
    return this._identitySpid;
  }

  set identitySpid(value: boolean) {
    this._identitySpid = value;
  }

  get isecProfile(): boolean {
    return this._isecProfile;
  }

  set isecProfile(value: boolean) {
    this._isecProfile = value;
  }

  get mainDomain(): string {
    return this._mainDomain;
  }

  set mainDomain(value: string) {
    this._mainDomain = value;
  }

  get management(): Management {
    return this._management;
  }

  set management(value: Management) {
    this._management = value;
  }

  get noIdentity(): boolean {
    return this._noIdentity;
  }

  set noIdentity(value: boolean) {
    this._noIdentity = value;
  }

  get optional(): boolean {
    return this._optional;
  }

  set optional(value: boolean) {
    this._optional = value;
  }

  get optionalOrder(): boolean {
    return this._optionalOrder;
  }

  set optionalOrder(value: boolean) {
    this._optionalOrder = value;
  }

  get passwordPolicy(): string {
    return this._passwordPolicy;
  }

  set passwordPolicy(value: string) {
    this._passwordPolicy = value;
  }

  get postActivationName(): string {
    return this._postActivationName;
  }

  set postActivationName(value: string) {
    this._postActivationName = value;
  }

  get productsCompositions(): Array<ProductCompositionModel> {
    return this._productsCompositions;
  }

  set productsCompositions(value: Array<ProductCompositionModel>) {
    this._productsCompositions = value;
  }

  get properties(): Array<PropertyModel> {
    return this._properties;
  }

  set properties(value: Array<PropertyModel>) {
    this._properties = value;
  }

  get reactivationCode(): string {
    return this._reactivationCode;
  }

  set reactivationCode(value: string) {
    this._reactivationCode = value;
  }

  get request(): RequestModel {
    return this._request;
  }

  set request(value: RequestModel) {
    this._request = value;
  }

  get secondaryDomains(): Array<string> {
    return this._secondaryDomains;
  }

  set secondaryDomains(value: Array<string>) {
    this._secondaryDomains = value;
  }

  get active(): number {
    return this._active;
  }

  set active(value: number) {
    this._active = value;
  }

  get max(): number {
    return this._max;
  }

  set max(value: number) {
    this._max = value;
  }
}
